var _defs, _g, _g2, _path, _path2, _ellipse, _g3, _rect, _rect2, _path3, _path4, _g4, _path5, _polygon, _path6, _g5, _path7, _path8, _g6, _g7, _path9, _rect3, _g8, _path0, _path1, _path10, _path11, _g9, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0505_achievement",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    "data-imageid": "achievement-10",
    imageName: "Achievement",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1_achievement-10 {\r\n                fill: #fff;\r\n            }\r\n\r\n            .cls-2_achievement-10 {\r\n                fill: #f4a28c;\r\n            }\r\n\r\n            .cls-3_achievement-10 {\r\n                opacity: .46;\r\n            }\r\n\r\n            .cls-3_achievement-10,\r\n            .cls-4_achievement-10,\r\n            .cls-5_achievement-10,\r\n            .cls-6_achievement-10,\r\n            .cls-7_achievement-10 {\r\n                fill: none;\r\n            }\r\n\r\n            .cls-8_achievement-10 {\r\n                fill: #ce8172;\r\n            }\r\n\r\n            .cls-9_achievement-10 {\r\n                fill: #e6e6e6;\r\n            }\r\n\r\n            .cls-4_achievement-10 {\r\n                opacity: .08;\r\n            }\r\n\r\n            .cls-5_achievement-10 {\r\n                opacity: .31;\r\n            }\r\n\r\n            .cls-6_achievement-10 {\r\n                opacity: .3;\r\n            }\r\n\r\n            .cls-7_achievement-10 {\r\n                opacity: .77;\r\n            }\r\n\r\n            .cls-10_achievement-10 {\r\n                fill: #24285b;\r\n            }\r\n\r\n            .cls-11_achievement-10 {\r\n                fill: #000001;\r\n            }\r\n\r\n            .cls-12_achievement-10 {\r\n                fill: #ffd200;\r\n            }\r\n\r\n            .cls-13_achievement-10 {\r\n                fill: #a20a0a;\r\n            }\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg_achievement-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6_achievement-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9_achievement-10",
    d: "m388.51,81.67c50.91,22.14,99.02,81.82,102,157.99,3,76.88-25.04,148.42-107.86,183.25-84.53,35.55-300.87,42.2-346.24-61.05C-8.97,258.6-1.22,127.13,88.81,81.86c63.11-31.73,200.26-43.42,299.7-.19Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 337.76,
    y: 113.94,
    width: 24.75,
    height: 11.86,
    transform: "translate(-12.64 193.04) rotate(-30.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 409.06,
    y: 301.56,
    width: 24.75,
    height: 11.86,
    transform: "translate(-97.57 254.65) rotate(-30.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 413.85,
    y: 197.72,
    width: 24.75,
    height: 11.86,
    transform: "translate(97.3 -135.39) rotate(20.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 56.66,
    y: 168.2,
    width: 24.75,
    height: 11.86,
    transform: "translate(64.79 -13.14) rotate(20.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 334.63,
    y: 389.58,
    width: 24.75,
    height: 11.86,
    transform: "translate(-177.33 351.82) rotate(-43.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 70.32,
    y: 266.92,
    width: 24.75,
    height: 11.86,
    transform: "translate(137.48 552.63) rotate(-174.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 251.73,
    y: 84.68,
    width: 24.75,
    height: 11.86,
    transform: "translate(239.66 368.76) rotate(-103.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 327.1,
    y: 261.24,
    width: 24.75,
    height: 11.86,
    transform: "translate(161.77 660.92) rotate(-103.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 131.92,
    y: 109.41,
    width: 24.75,
    height: 11.86,
    transform: "translate(-38.06 144.88) rotate(-47.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_achievement-10",
    x: 67.4,
    y: 345.9,
    width: 24.75,
    height: 11.86,
    transform: "translate(431.06 433.98) rotate(115.94)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "person_achievement-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13_achievement-10 targetColor",
    d: "m241.05,138.32l32.11,14.2c23.95,10.59,51.96,5.06,70.09-13.83l31.61-32.94,12.04,8.25-26.57,40.08c-22.93,34.59-63.81,52.76-104.85,46.61l-46.67-7,32.25-55.38Z",
    style: {
      fill: "rgb(104, 225, 253)"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3_achievement-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1_achievement-10",
    d: "m241.05,138.32l32.11,14.2c23.95,10.59,51.96,5.06,70.09-13.83l31.61-32.94,12.04,8.25-26.57,40.08c-22.93,34.59-63.81,52.76-104.85,46.61l-46.67-7,32.25-55.38Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_achievement-10",
    d: "m386.89,114.01s22.15-2.95,16.15-9.16c-6-6.21-28.19.91-28.19.91l12.04,8.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_achievement-10",
    d: "m411.05,32.63h-43.19s-4.57,34.16,21.6,34.16c0,0,24.98.82,21.6-34.16Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12_achievement-10",
    cx: 389.43,
    cy: 33.04,
    rx: 21.62,
    ry: 6.17
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4_achievement-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11_achievement-10",
    cx: 389.43,
    cy: 33.04,
    rx: 21.62,
    ry: 6.17
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10_achievement-10",
    x: 379.34,
    y: 81.32,
    width: 21.69,
    height: 21.69,
    transform: "translate(780.37 184.33) rotate(-180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12_achievement-10",
    x: 386.89,
    y: 60.03,
    width: 4.62,
    height: 21.29,
    transform: "translate(778.4 141.36) rotate(-180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_achievement-10",
    d: "m415.68,63.44h-22.04v-3h22.04c3.82,0,6.92-3.11,6.92-6.92s-3.11-6.92-6.92-6.92h-7.73v-3h7.73c5.47,0,9.92,4.45,9.92,9.92s-4.45,9.92-9.92,9.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_achievement-10",
    d: "m385.21,63.44h-22.04c-5.47,0-9.92-4.45-9.92-9.92s4.45-9.92,9.92-9.92h7.73v3h-7.73c-3.82,0-6.92,3.11-6.92,6.92s3.11,6.92,6.92,6.92h22.04v3Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3_achievement-10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1_achievement-10",
    cx: 396.64,
    cy: 51.2,
    r: 7.44
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_achievement-10",
    d: "m195.03,102.56s4.9,9.48,5.94,16.69c.42,2.93-1.65,5.68-4.58,6.06-3.64.47-8.7.05-11.95-4.71l-6.5-7.4s-3.91-4.78,0-11.07c3.91-6.29,14.38-5.5,17.08.42Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2_achievement-10",
    points: "181.21 110.46 179.67 145.38 198.98 144.86 192.35 119.65 181.21 110.46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_achievement-10",
    d: "m197.81,108.69l4.31,2.67c1.07.66,1.08,2.2.03,2.89l-3.48,2.26-.87-7.82Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5_achievement-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8_achievement-10",
    d: "m193.91,125.43s-3.62-.32-6.63-2.99c0,0,1,6.32,8.69,11.8l-2.06-8.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13_achievement-10 targetColor",
    d: "m237.22,455.01s2.84,7.88,9.95,8.48,8.99,7.56,2.58,9.38c-6.4,1.81-22.91-6.42-22.91-6.42l.46-10.28,9.91-1.17Z",
    style: {
      fill: "rgb(104, 225, 253)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13_achievement-10 targetColor",
    d: "m140.82,455.01s-2.84,7.88-9.95,8.48c-7.12.6-8.99,7.56-2.58,9.38,6.4,1.81,22.91-6.42,22.91-6.42l-.46-10.28-9.91-1.17Z",
    style: {
      fill: "rgb(104, 225, 253)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13_achievement-10 targetColor",
    d: "m225.58,135.16c-24.21.41-56.86,4.67-92.15,19.7-18.87,8.04-27.13,30.28-17.94,48.62l50.14,100.01,92.96-5.5s16.92-56.21,13.53-119.8c-1.31-24.52-21.99-43.45-46.53-43.04Z",
    style: {
      fill: "rgb(104, 225, 253)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10_achievement-10",
    d: "m165.63,303.49l-27.78,152.95h13.89s34.82-83.04,34.82-83.04c12.33-29.41,34.07-53.89,61.81-69.62l10.22-5.79-92.96,5.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10_achievement-10",
    d: "m258.59,297.99l-14.35,158.45h-18.46s4.31-119.23-28.99-144.61l61.8-13.84Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4_achievement-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11_achievement-10",
    d: "m159.47,162.21s23.74,15.26,16.27,62.2c-7.47,46.93,22.48,77.15,22.48,77.15l-32.59,1.93s-20.88-43.56-26.47-52.8c-5.59-9.24,20.31-88.47,20.31-88.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13_achievement-10 targetColor",
    d: "m164.29,176.42c.1-21.26-26.47-31.07-40.69-15.27-10.08,11.21-20.05,27.29-22.63,48.58-5.66,46.69.57,148.63.57,148.63h16.9s11.41-101.88,36.33-148.63c6.95-13.03,9.48-24.11,9.52-33.31Z",
    style: {
      fill: "rgb(104, 225, 253)"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3_achievement-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1_achievement-10",
    d: "m164.29,176.42c.1-21.26-26.47-31.07-40.69-15.27-10.08,11.21-20.05,27.29-22.63,48.58-5.66,46.69.57,148.63.57,148.63h16.9s11.41-101.88,36.33-148.63c6.95-13.03,9.48-24.11,9.52-33.31Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10_achievement-10",
    d: "m125.52,388.32h-2v-7.74c0-4.89-3.98-8.88-8.88-8.88h-9.25c-4.89,0-8.88,3.98-8.88,8.88v7.21h-2v-7.21c0-6,4.88-10.88,10.88-10.88h9.25c6,0,10.88,4.88,10.88,10.88v7.74Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12_achievement-10",
    x: 75.89,
    y: 384.94,
    width: 70.48,
    height: 45.91
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4_achievement-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11_achievement-10",
    d: "m75.89,406.48s26.41,22.69,70.48,16.02v8.36h-70.48v-24.38Z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_achievement-10",
    d: "m104.47,358.36s-5.07,16.82,1.6,16.82,14.68,3.2,9.61-16.82h-11.21Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10_achievement-10",
    d: "m180.48,123.21l6.66-3.58.68-3.54s3.18-4.24,0-9.38c0,0,12.78-6.21,9.79-11.55-3-5.34-12.44-12.46-21.6-5.69-9.16,6.76-13.79,19.1,4.47,33.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_achievement-10",
    d: "m188.02,115.32s-1.64-3.77-4.37-2.3c-2.73,1.47-.4,6.93,3.69,5.84l.68-3.54Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1_achievement-10",
    d: "m173.91,141.6s15.1-4.75,34.89-5.57c0,0,16.27,64.95,3.45,117.27,0,0-18.22-65.9-38.34-111.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13_achievement-10 targetColor",
    d: "m173.91,141.6s-.63-7.89,4.97-8.16c5.61-.27,9.14.79,9.14.79,0,0,16.38-12.84,20.77,1.79,0,0-23.44,2.6-34.89,5.57Z",
    style: {
      fill: "rgb(104, 225, 253)"
    }
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7_achievement-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1_achievement-10",
    d: "m173.91,141.6s-.63-7.89,4.97-8.16c5.61-.27,9.14.79,9.14.79,0,0,16.38-12.84,20.77,1.79,0,0-23.44,2.6-34.89,5.57Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10_achievement-10",
    d: "m185.36,139.15s-1.86-6.17,2.04-6.94c3.9-.77,7.42-3.28,8.25,4.63.83,7.92-7.11,8.73-10.29,2.31Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10_achievement-10",
    d: "m187.94,142.28s12.29,43.55,12.43,71.54l11.88,39.47s5.56-21.41,4.92-42.98c0,0-12.72-57.29-21.63-70.69l-7.6,2.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinning);
export default __webpack_public_path__ + "static/media/winning.c82867126fbeaffd6287b4cee43202f5.svg";
export { ForwardRef as ReactComponent };